import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { endpoints } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../../../shared/models/base.result.model';
import { PixLimitsReturn } from '../models/limits-return.model';

@Injectable()
export class PixLimitsService {

	private selectedLimit: PixLimitsReturn;
	private url = endpoints.pix;

	constructor(private http: HttpClient) { }

	getLimits(): Observable<BaseResult<PixLimitsReturn>> {
		return this.http.get<BaseResult<PixLimitsReturn>>(`${this.url.limits}`, {params: {tipoLimite: 'PIX'}});
	}

	getSelectedLimit = () => this.selectedLimit;

	setSelectedLimit = (limit: PixLimitsReturn) => this.selectedLimit = limit;

	changeLimitValue(changeLimitData: any): Observable<any> {
		const dataChangeLimitData = {
			Tipo: changeLimitData.tipo,
			Valor: changeLimitData.valor
		};

		return this.http.put(this.url.limits, dataChangeLimitData);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/limits/limits.service.ts